const rawCategoryEventCodes = [
    {
        category: { key: "othersCodes", label: "Others", cssClass: "warning-codes" },
        items: []
    },
    {
        /**
        * Codes to pinpoint the error location when these messages are displayed in the app UI.
        */
        category: { key: "ErrorCodes", label: "Errors", cssClass: "error-codes" },
        items: [
            { "code": "ERROR_5001", "title": "PrintCustomerInvoice Exception when executing PrintCustomerInvoice." },
            { "code": "ERROR_5002", "title": "ValidateCardPayment session or session key becomes null" },
            { "code": "ERROR_5003", "title": "SplashViewModel Exception when getMasterDataUseCase." },
            { "code": "ERROR_5004", "title": "PrintBitmap Exception when printing Bill." },
            { "code": "ERROR_5005", "title": "SplashViewModel Exception when clientLoginUseCase." },
            { "code": "ERROR_5006", "title": "CloseOpWorker response is null. TODO:" },
            { "code": "ERROR_5007", "title": "PrintReceipt exception when printing receipt." },
            { "code": "ERROR_5007A", "title": "PrintReceipt order is null." },
            { "code": "ERROR_5008", "title": "UpgradeSeatSale order is null." },
            { "code": "ERROR_5009", "title": "GetAircraftSchedules HTTPException." },
            { "code": "ERROR_5010", "title": "CrewLoginViewModel exception in getAllCrew." },
            { "code": "ERROR_5011", "title": "CrewLoginViewModel exception in getAllAircrafts." },
            { "code": "ERROR_5012", "title": "CrewLoginViewModel exception in getAircraftSchedules." },
            { "code": "ERROR_5013", "title": "CrewLoginViewModel res error in getAircraftSchedules." },
            { "code": "ERROR_5014", "title": "CloseSector exception when filtering itemstocks." },
            { "code": "ERROR_5015", "title": "IfeScreen viewModel.ifeState.value.ifeConnectionFailed" },
            { "code": "ERROR_5016", "title": "ReprintReceipt exception when printing receipt." },
            { "code": "ERROR_5017", "title": "GetOperatingSectors HTTPException." },
            { "code": "ERROR_5018", "title": "GetOperatingSectors generic exception" },
            { "code": "ERROR_5019", "title": "GetPriceListInfo HTTPException." },
            { "code": "ERROR_5020", "title": "GetPriceListInfo generic exception." },
            { "code": "ERROR_5021", "title": "SectorLoginViewModel exception when getCrewSchedules." },
            { "code": "ERROR_5022", "title": "SectorLoginViewModel resource error." },
            { "code": "ERROR_5023", "title": "SectorLoginViewModel getPriceListInfo generic exception." },
            { "code": "ERROR_5024", "title": "SectorLoginViewModel changeCrew generic exception." },
            { "code": "ERROR_5025", "title": "SectorLoginViewModel sectorLogin generic exception." },
            { "code": "ERROR_5026", "title": "SessionSyncWorker syncSession generic exception." },
            { "code": "ERROR_5027", "title": "SessionSyncWorker syncOrders generic exception." },
            { "code": "ERROR_5028", "title": "SessionSyncWorker syncOffloadSummary generic exception." },
            { "code": "ERROR_5029", "title": "SessionSyncWorker syncCustomerInteractions generic exception." },
            { "code": "ERROR_5030", "title": "ClientLogin generic exception." },
            { "code": "ERROR_5031", "title": "GetMasterData HTTPException." },
            { "code": "ERROR_5032", "title": "GetMasterData generic exception." },
            { "code": "ERROR_5033", "title": "SplashViewModel clientLoginUseCase resource error." },
            { "code": "ERROR_5034", "title": "SplashViewModel getMasterDataUseCase resource error." },
            { "code": "ERROR_5035", "title": "Extensions Exception Generic." },
            { "code": "ERROR_5036", "title": "ValidateCardPayment Card sale is declined because the order is not present in nGO" },
            { "code": "ERROR_5037", "title": "ValidateCardPayment Something went wrong and card sale is cancelled" },
            { "code": "ERROR_5038", "title": "ExceptionHandler Exception Generic." },
            { "code": "ERROR_5039", "title": "MswipePaymentCancellationService response data is null." },
            { "code": "ERROR_5040", "title": "printBitmap onError" },
            { "code": "ERROR_5041", "title": "InitializePrebookSale error in placePrebookSale" },
            { "code": "ERROR_5042", "title": "SessionRepositoryImpl syncOrders jsonException" },
            { "code": "ERROR_5043", "title": "CrewLoginViewModel Exception when getMasterDataUseCase" },
            { "code": "ERROR_5044", "title": "CrewLoginViewModel getMasterDataUseCase resource error" },
            { "code": "ERROR_5045", "title": "SessionRepositoryImpl syncCustomerInteractions jsonException" }
        ]
    },

    /**
    * Codes to pinpoint the error location when these messages are displayed in the app UI.
    */
    {
        category: { key: "NetworkErrorCodes", label: "Network Errors", cssClass: "warning-codes" },
        items: [
            { "code": "ERROR_6001", "title": "GetOperatingSectors connection to server failed" },
            { "code": "ERROR_6002", "title": "GetPriceListInfo connection to server failed" },
            { "code": "ERROR_6003", "title": "GetMasterData connection to server failed" },
            { "code": "ERROR_6004", "title": "ClientLogin internet not available" }
        ]
    },
    {
        category: { key: "EventTypeCodes", label: "Events", cssClass: "info-codes" },
        items: [
            { "code": "EVENT_70001", "title": "CardPayFailed before emitting card failure reason", cssClass: 'error-codes' },
            { "code": "EVENT_70002", "title": "ValidateCardPayment Expired card declined" },
            { "code": "EVENT_70003", "title": "ValidateCardPayment A card sale is rejected due to suspicious activity" },
            { "code": "EVENT_70004", "title": "ValidateCardPayment Sale Declined. Max card amount" },
            { "code": "EVENT_70005", "title": "ValidateCardPayment This card is rejected due to past failures" },
            { "code": "EVENT_70006", "title": "ValidateCardPayment Card sale approved" },
            { "code": "EVENT_70007", "title": "ValidateCardPayment card sale is cancelled generic reason" },
            { "code": "EVENT_70007A", "title": "ValidateCardPayment order not present in nGO" },
            { "code": "EVENT_70008", "title": "voidPendingOrder" },
            { "code": "EVENT_70009", "title": "ApiInterceptor API call started" },
            { "code": "EVENT_70010", "title": "ApiInterceptor API call ended." },
            { "code": "EVENT_70011", "title": "OrderServiceImpl.kt Logging all order details except card orders" },
            { "code": "EVENT_70012", "title": "CardPayViewModel.kt Logging card order details" },
            { "code": "EVENT_70013", "title": "PaxManifestRepositoryImpl error when updating manifest (getPaxManifest)." },
            { "code": "EVENT_70014", "title": "PaxManifestWorker fetching manifest started." },
            { "code": "EVENT_70015", "title": "PaxManifestWorker fetching manifest ended." },
            { "code": "EVENT_70016", "title": "" },
            { "code": "EVENT_70017", "title": "SessionPaxManifestWorker fetching manifest started." },
            { "code": "EVENT_70018", "title": "SessionPaxManifestWorker fetching manifest ended." },
            { "code": "EVENT_70019", "title": "PaymentStatusSyncWorker started." },
            { "code": "EVENT_70020", "title": "PaymentStatusSyncWorker ended." },
            { "code": "EVENT_70021", "title": "" },
            { "code": "EVENT_70022", "title": "" },
            { "code": "EVENT_70023", "title": "ScheduleSyncWorker started." },
            { "code": "EVENT_70024", "title": "ScheduleSyncWorker getSchedulesV2 ended." },
            { "code": "EVENT_70025", "title": "ScheduleSyncWorker getSchedules ended." },
            { "code": "EVENT_70026", "title": "ScheduleSyncWorker generic error." },
            { "code": "EVENT_70027", "title": "" },
            { "code": "EVENT_70028", "title": "" },
            { "code": "EVENT_70029", "title": "CheckForUpdateWorker started." },
            { "code": "EVENT_70030", "title": "CheckForUpdateWorker ended." },
            { "code": "EVENT_70031", "title": "CheckForUpdateWorker generic error." },
            { "code": "EVENT_70032", "title": "DeclinedCardSyncWorker started." },
            { "code": "EVENT_70033", "title": "DeclinedCardSyncWorker syncDeclinedCardOrders started." },
            { "code": "EVENT_70034", "title": "DeclinedCardSyncWorker ended." },
            { "code": "EVENT_70035", "title": "SessionSyncWorker timezone mismatch." },
            { "code": "EVENT_70036", "title": "SectorLoginWorker started." },
            { "code": "EVENT_70037", "title": "SectorLoginWorker ended." },
            { "code": "EVENT_70038", "title": "SessionSyncWorker getSyncPendingSessions started." },
            { "code": "EVENT_70039", "title": "SessionSyncWorker getSyncPendingSessions ended." },
            { "code": "EVENT_70040", "title": "SessionSyncWorker syncSession started." },
            { "code": "EVENT_70041", "title": "SessionSyncWorker syncSession generic error." },
            { "code": "EVENT_70042", "title": "SessionSyncWorker syncSession ended." },
            { "code": "EVENT_70043", "title": "SessionSyncWorker syncOrders started." },
            { "code": "EVENT_70044", "title": "SessionSyncWorker syncOrders generic error." },
            { "code": "EVENT_70045", "title": "SessionSyncWorker syncOrders ended." },
            { "code": "EVENT_70046", "title": "SessionSyncWorker syncOffloadSummary started." },
            { "code": "EVENT_70047", "title": "CardPayActivity general log." },
            { "code": "EVENT_70048", "title": "OrderServiceImpl placing order in placeOrder function." },
            { "code": "EVENT_70049", "title": "CardPayActivity card payment initialisation" },
            { "code": "EVENT_70050", "title": "CardPayActivity card validation successful" },
            { "code": "EVENT_70051", "title": "CardPayActivity card payment successful" },
            { "code": "EVENT_70052", "title": "CheckForUpdateWorker.kt logging version details if new version is available" },
            { "code": "EVENT_70053", "title": "CardPayActivity payment failed and sale voided" },
            { "code": "EVENT_70054", "title": "OrderServiceImpl before accepting card order inside acceptCardOrder fun" },
            { "code": "EVENT_70055", "title": "CardPayActivity card validation error" },
            { "code": "EVENT_70056", "title": "SessionRepositoryImpl order inside syncOrders fun" },
            { "code": "EVENT_70057", "title": "SessionRepositoryImpl order inside syncOrders fun" },
            { "code": "EVENT_70058", "title": "OrderServiceImpl marking prebook sale as cancelled" },
            { "code": "EVENT_70059", "title": "VoidCardSale voided the card sale" },
            { "code": "EVENT_70060", "title": "OrderServiceImpl updating order status to cancelled" },
            { "code": "EVENT_70061", "title": "VoidCardSale before voiding a card sale" },
            { "code": "EVENT_70062", "title": "OrderServiceImpl cancelled an order" },
            { "code": "EVENT_70063", "title": "Logs SIM info and SIM mismatch" },
            { "code": "EVENT_70064", "title": "Logs IMEI info and IMEI mismatch" },
            { "code": "EVENT_70065", "title": "Logs info related to Device" },
            { "code": "EVENT_70066", "title": "MosambeeCancellationService initialising mosambee callback for card payment cancellation" },
            { "code": "EVENT_70067", "title": "MosambeeCancellationService onResult data" },
            { "code": "EVENT_70068", "title": "MosambeeCancellationService onCommand data" },
            { "code": "EVENT_70069", "title": "MosambeePaymentInitService initializeSetup of mosambee callback for Payment initialisation" },
            { "code": "EVENT_70070", "title": "MosambeePaymentInitService onResult data if result is true" },
            { "code": "EVENT_70071", "title": "MosambeePaymentInitService onResult data if result is false" },
            { "code": "EVENT_70072", "title": "MosambeePaymentInitService onCommand data" },
            { "code": "EVENT_70073", "title": "MosambeePaymentSyncService initialising mosambee callback for syncing card payments" },
            { "code": "EVENT_70074", "title": "MosambeePaymentSyncService onResult data if result is true" },
            { "code": "EVENT_70075", "title": "MosambeePaymentSyncService onResult data if result is false" },
            { "code": "EVENT_70076", "title": "MosambeePaymentSyncService number of successfull transactions" },
            { "code": "EVENT_70077", "title": "MosambeePaymentSyncService details of a successfull transcation" },
            { "code": "EVENT_70078", "title": "MosambeePaymentSyncService number of failed transactions" },
            { "code": "EVENT_70079", "title": "MosambeePaymentSyncService details of a failed transaction" },
            { "code": "EVENT_70080", "title": "MosambeePaymentSyncService onCommand data" },
            { "code": "EVENT_70081", "title": "SessionRepositoryImpl json for syncSession req" },
            { "code": "EVENT_70082", "title": "SessionRepositoryImpl json for syncOrders req" },
            { "code": "EVENT_70083", "title": "SessionRepositoryImpl json for syncOffloadSummary req" },
            { "code": "EVENT_70084", "title": "SessionRepositoryImpl json for syncDeclinedCardSales req" },
            { "code": "EVENT_70085", "title": "InventoryRepoImpl json for syncOfflinePaymentStatus req" },
            { "code": "EVENT_70086", "title": "InventoryRepoImpl syncing offline payment to db" },
            { "code": "EVENT_70087", "title": "InventoryRepoImpl syncing offline payment exception" },
            { "code": "EVENT_70088", "title": "SessionRepositoryImpl Declined card Sales" },
            { "code": "EVENT_70089", "title": "InventoryRepoImpl adding declined cards to DB" },
            { "code": "EVENT_70090", "title": "ValidateCardPayment adding declined card sale(card misuse)" },
            { "code": "EVENT_70091", "title": "PrintReceipt printing receipt" },
            { "code": "EVENT_70092", "title": "SessionRepositoryImpl updating session Id and transferInReportId with the data from crewLogin API response" },
            { "code": "EVENT_70093", "title": "SessionRepositoryImpl updating session while initiating sector closing" },
            { "code": "EVENT_70094", "title": "SessionRepositoryImpl updating session table while sector cancelling" },
            { "code": "EVENT_70095", "title": "SessionRepositoryImpl updating session table after sector closing" },
            { "code": "EVENT_70096", "title": "SessionRepositoryImpl updating session table fields synced and sales synced" },
            { "code": "EVENT_70097", "title": "SessionRepositoryImpl adding a session to DB in syncSession fun" },
            { "code": "EVENT_70098", "title": "SessionRepositoryImpl synced field of session table true" },
            { "code": "EVENT_70099", "title": "SessionRepositoryImpl close operation" },
            { "code": "EVENT_70100", "title": "SessionSyncWorker getting sessions which are not synced but sales finished" },
            { "code": "EVENT_70101", "title": "SessionRepositoryImpl inside syncSession fun" },
            { "code": "EVENT_70102", "title": "SectorLogin.kt adding new session to DB while logging into a sector" },
            { "code": "EVENT_70103", "title": "PaxManifestRepositoryImpl.kt exception while fetching latest manifest" },
            { "code": "EVENT_70104", "title": "SessionRepositoryImpl.kt syncing customer interactions" },
            { "code": "EVENT_70105", "title": "SessionRepositoryImpl.kt updating session id from api response in syncOffloadSummary fun" },
            { "code": "EVENT_70106", "title": "SessionRepositoryImpl.kt updating sales synced field of a session to true from syncOffloadSummary fun" },
            { "code": "EVENT_70107", "title": "SessionSyncWorker.kt updating sales synced and session synced fields of current session if customer interactions are empty and session did not get updated in syncOffloadSummary fun" },
            { "code": "EVENT_70108", "title": "Not in use." },
            { "code": "EVENT_70109", "title": "PaxManifestRepositoryImpl.kt event for logging the sector info value" },
            { "code": "EVENT_70110", "title": "To log the Database instances" },
            { "code": "EVENT_70111", "title": "To log the status of the file app_installed.txt" },
            { "code": "EVENT_70112", "title": " MainActivity: Activity launch event" }
        ]
    }
];
const getRawEventCodes = () => {
    return rawCategoryEventCodes;
}
const getAllEventCodes = () => {
    return rawCategoryEventCodes.map((item) => item.items).flat();
}
const getEventCategories = () => {
    return rawCategoryEventCodes.map((item) => item.category);
}
const getEventCodesByCategory = (category = '') => {
    const categoryObj = rawCategoryEventCodes.find((item) => item.category.key === category);
    return categoryObj ? categoryObj.items : [];
}
const getEventCategoryLabel = (key) => {
    const categoryObj = rawCategoryEventCodes.find((item) => item.category.key === key);
    return categoryObj ? categoryObj.category.label : '';
}
const getEventCategoryByEventCode = (eventCode = '') => {
    for (const item of rawCategoryEventCodes) {
        if (item.items.some((codeObj) => codeObj.code === eventCode)) {
            return item.category;
        }
    }
    return null;
}

const masterEventCodes = {
    getRawEventCodes: getRawEventCodes,
    getAllEventCodes: getAllEventCodes,
    getEventCategories: getEventCategories,
    getEventCategoryLabel: getEventCategoryLabel,
    getEventCategoryByEventCode: getEventCategoryByEventCode,
    getEventCodesByCategory: getEventCodesByCategory
};
export default masterEventCodes;